import { combineEpics } from 'redux-observable';
import { closePricingProfileBeforeRemoveEpic } from './_epics/closePricingProfileBeforeRemove.epic';
import { reloadPricingProfileListEpic } from './_epics/reloadPricingProfileList.epic';
import { toggleViewPricingProfileSidebarEpic } from './_epics/toggleViewPricingProfileSidebar.epic';

export const controllerPricingProfileEpic = combineEpics(
  closePricingProfileBeforeRemoveEpic,
  reloadPricingProfileListEpic,
  toggleViewPricingProfileSidebarEpic,
);
